export type TipoCanalVenda = 'ifood' | '99food' | 'keeta' | 'opendelivery';
export type SituacaoCanalVenda = 'aberta' | 'fechada' | 'desativada' | 'sem-comunicacao' | 'desconhecida';
export interface CanalVenda {
  tipo: TipoCanalVenda;
  marca: string;
  rotulo: string;
  nome: string;
  loja: any;
  situacao: SituacaoCanalVenda;
  mensagem: string;
  controlavel: boolean;
  url: string;
  logo?: string;
}

/** Usa o status consultado, nunca a existência de credenciais como sinal de loja aberta. */
export function listeCanaisVenda(empresa: any, monitor: any): CanalVenda[] {
  const canais: CanalVenda[] = [];
  const montar = (tipo: TipoCanalVenda, rotulo: string, configuradas: any[], consultadas: any[]) => {
    if (!configuradas.length) return;
    const semConsulta = (config: any) => ({
      id: config.id, loja: config.nomeLojaExterna || config.nomeLoja || config.idLoja || empresa.nome,
      parceiro: config.modoConfiguracao === 'aiqfome' ? 'aiqfome' : config.nomeAplicacao,
      status: 'UNKNOWN', desativado: tipo === 'opendelivery' ? !config.ativa : !!config.desativado
    });
    const lojas = consultadas?.length ? [...consultadas] : configuradas.map(semConsulta);
    // Algumas consultas omitem integrações desativadas (iFood, por exemplo).
    if (consultadas?.length && consultadas.length < configuradas.length) {
      configuradas.forEach((config, indice) => {
        const id = tipo === 'keeta' ? config.idLoja : config.id;
        const nome = config.nomeLojaExterna || config.nomeLoja;
        const encontrada = consultadas.some(loja => (id != null && loja.id != null && String(id) === String(loja.id)) ||
          (nome && nome === loja.loja));
        if (!encontrada && (id != null || nome || indice >= consultadas.length)) lojas.push(semConsulta(config));
      });
    }
    lojas.forEach(loja => {
      const marca = tipo === 'opendelivery' && loja.parceiro === 'aiqfome' ? 'aiqfome' : tipo;
      const situacao: SituacaoCanalVenda = loja.desativado ? 'desativada' :
        (monitor.errosStatusCanais?.[tipo] || loja.desconectada || loja.status === 'ERROR' ||
          (!loja.status && loja.aberta === false && /n[aã]o foi poss[ií]vel obter status/i.test(loja.mensagem || '')))
          ? 'sem-comunicacao' :
          (loja.status === 'UNKNOWN' || loja.mensagem === 'Status desconhecido' ||
            (tipo === '99food' && !loja.mensagem) || typeof loja.aberta !== 'boolean')
            ? 'desconhecida' : (loja.aberta ? 'aberta' : 'fechada');
      canais.push({tipo, marca, loja, situacao,
        rotulo: tipo !== 'opendelivery' ? rotulo : (marca === 'aiqfome' ? 'aiqfome' :
          loja.rotulo || `OpenDelivery (${loja.parceiro || 'parceiro'})`),
        nome: String(loja.loja || loja.id || empresa.nome || 'Loja sem nome'),
        mensagem: monitor.errosStatusCanais?.[tipo] || loja.mensagem || '',
        // A API atual da Keeta opera uma única configuração, sem receber a loja selecionada.
        controlavel: (tipo === '99food' || (tipo === 'keeta' && configuradas.length === 1)) &&
          (situacao === 'aberta' || situacao === 'fechada'),
        url: '/admin/loja/tab/' + (tipo === 'opendelivery' ? 'opendeliveryss' : tipo),
        logo: ['ifood', 'aiqfome'].includes(marca) ? `/assets/icons/logo-${marca}.png` : undefined
      });
    });
  };
  montar('ifood', 'iFood', (empresa.integracoesIfood || []).filter(i => i.orderApi || i.shippingApi), monitor.lojasIfood);
  montar('99food', '99Food', empresa.integracoes99Food || [], monitor.lojas99Food);
  montar('keeta', 'Keeta', empresa.integracoesKeeta || [], monitor.lojasKeeta);
  montar('opendelivery', 'OpenDelivery', empresa.openDeliverySoftwareService?.integracoes || [], monitor.lojasOpenDelivery);
  return canais;
}
